module.exports = __webpack_public_path__ + "img/taxi-solid.d1a40ef3.svg";